import Rest from '@services/Rest'

/**
 * @typedef {DraftObservationService}
 */
export default class DraftObservationService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/product/draftObservation'
}
